/* JODUM story homepage: reveal on scroll + sticky mobile CTA. */
(function () {
  if (window.__jodumStoryInit) return;
  window.__jodumStoryInit = true;

  function init() {
    var reveals = document.querySelectorAll('.js-reveal');
    if ('IntersectionObserver' in window && reveals.length) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-in');
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.18 }
      );
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    var sticky = document.querySelector('.js-sticky');
    var hero = document.getElementById('js-hero');
    var offer = document.getElementById('js-offer');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var heroGone = false;
      var offerSeen = false;
      var sync = function () {
        sticky.classList.toggle('is-on', heroGone && !offerSeen);
      };
      new IntersectionObserver(function (entries) {
        heroGone = !entries[0].isIntersecting;
        sync();
      }, { threshold: 0.05 }).observe(hero);
      if (offer) {
        new IntersectionObserver(function (entries) {
          offerSeen = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.15 }).observe(offer);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
